import { render, staticRenderFns } from "./tabs-tertiary.vue?vue&type=template&id=ec6c4aea&scoped=true"
import script from "./tabs-tertiary.vue?vue&type=script&lang=js"
export * from "./tabs-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6c4aea",
  null
  
)

export default component.exports